import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Span, StateIcon, StateText } from 'ui';

/**
 *  Component for status view of ticket
 *
 * @param {boolean} isNew - is new ticket
 * @param {boolean} isSaving - is saving state
 * @param {boolean} isDirty - is dirty state
 */
const TicketFormDetailStatus = ({
  isNew = false,
  isSaving = false,
  isDirty = false,
  hasError = false,
}) =>
  <>
    {isSaving &&
      <StateText severity={2}>
        <Span font-size={12} marginRight={5}>
          <FormattedMessage id='ticket.SAVING' />
        </Span>
        <StateIcon severity={2} type='exclamation-triangle' />
      </StateText>
    }
    {!isSaving && hasError &&
      <StateText severity={1}>
        <StateIcon severity={1} type='exclamation-triangle' />
        <Span font-size={12} marginRight={5}>
          <FormattedMessage id='ticket.MISSING_INFO' />
        </Span>
      </StateText>
    }
    {isDirty && !isSaving && !hasError &&
      <StateText severity={2}>
        <Span font-size={12} marginRight={5}>
          <FormattedMessage id='ticket.PENDING_CHANGES' />
        </Span>
        <StateIcon severity={2} type='exclamation-triangle' />
      </StateText>
    }

    {!isSaving && !isDirty && !isNew && !hasError &&
      <StateText severity={4}>
        <Span font-size={12} marginRight={5}>
          <FormattedMessage id='ticket.SAVED' />
        </Span>
        <StateIcon severity={4} type='check-circle' />
      </StateText>
    }
  </>;
TicketFormDetailStatus.propTypes = {
  isNew: PropTypes.bool,
  isSaving: PropTypes.bool,
  isDirty: PropTypes.bool,
  hasError: PropTypes.bool,
};

export default TicketFormDetailStatus;
